module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MoreInfo":"More Information"},"zh":{"MoreInfo":"更多信息"},"mm":{"MoreInfo":"အသေးစိတ်အချက်အလက်"}}')
  delete Component.options._Ctor
}
